import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { toggleExcludeMoyensAnnexes, search } from '../../../state/actions';
import { StateType } from '../../../../state/state.types';

const mapState = ({ queryParams }: StateType) => ({
  excludeMoyensAnnexes: queryParams.excludeMoyensAnnexes,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  toggleCheckbox() {
    dispatch(toggleExcludeMoyensAnnexes());
    dispatch(search({ reason: 'exclude' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
